import _ from "lodash";
import { LOAN_SENIORITY_TYPES } from "@loanbossinc/component-library";

export const getNoiPrefillForSupplementalCalculator = projections => {
  // let projections = this.props.dealProjections[this.props.match.params.dealId];
  if (!projections) {
    return null;
  }
  projections = _.sortBy(projections, "periodDate");
  let projectionDate = null;
  const today = new Date();
  for (let i = 0; i < projections.length; i++) {
    const currentProjection = projections[i];
    projectionDate = new Date(currentProjection.periodDate);
    if (projectionDate && projectionDate > today) {
      return projections[i].noi;
    }
  }

  return null;
};

export const getRateTypePrefillForSupplementalCalculator = loans => {
  if (!loans || loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR).length === 0) {
    return null;
  }
  const loanToUse = _.sortBy(loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR), "closingDate")[0];
  if (!loanToUse) {
    return null;
  }

  if (loanToUse.rateTypeRef) {
    return loanToUse.rateTypeRef.name?.toUpperCase();
  }

  return null;
};

export const getLoanWithEarliestClose = loans => {
  if (!loans || loans.length === 0) {
    return null;
  }

  return _.sortBy(loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR), "closingDate")[0];
};

export const getMostRecentSupplementalLoan = loans => {
  if (!loans || loans.length === 0) {
    return null;
  }

  return _.orderBy(loans.filter(x => x.loanSeniorityId === LOAN_SENIORITY_TYPES.SUPPLEMENTAL && Boolean(x.closingDate)), "closingDate", "desc")[0];
};
